import {Provider} from '@angular/core';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';

import {
  ListPersonTypesHttpAdapter
} from '@features/setting/infrastructure/http/list-person-types/list-person-types.http.adapter';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {
  ListPersonTypesUseCasePort
} from '@features/setting/application/use_cases/list-person-types/list-person-types.use-case.port';

export const ListPersonTypesHttpProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  {
    provide: ListPersonTypesUseCasePort,
    useClass: ListPersonTypesHttpAdapter
  }
];
